
import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface UserPermissions {
  canRead: boolean;
  canWrite: boolean;
  canGenerateReports: boolean;
  isAdmin: boolean;
}

export function usePermissions(): UserPermissions {
  const { profile } = useAuth();

  return useMemo(() => {
    if (!profile) {
      return {
        canRead: false,
        canWrite: false,
        canGenerateReports: false,
        isAdmin: false,
      };
    }

    // Check if user is admin
    const isAdmin = profile.user_role === 'admin' || profile.role === 'admin';

    // If admin, they have all permissions
    if (isAdmin) {
      return {
        canRead: true,
        canWrite: true,
        canGenerateReports: true,
        isAdmin: true,
      };
    }

    // For regular users, check custom permissions or default to read-only
    const permissions = profile.permissions || {
      read: true,
      write: false,
      admin: false,
      reports: true,
    };

    return {
      canRead: permissions.read,
      canWrite: permissions.write,
      canGenerateReports: permissions.reports,
      isAdmin: permissions.admin,
    };
  }, [profile]);
}
